import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './colors.scss';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Routes, Route, HashRouter } from 'react-router-dom';
import { Header } from './header';
import { utilList } from './list';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <HashRouter>
            <Routes>
                <Route index element={<App />} />
                <Route path="*" element={<><h1>404</h1><p>Page not found</p></>} />
                <Route path='/' element={<Header />}>
                    {Object.entries(utilList).map(([path, { component: Component, subRoutes }]) => (
                        <Route key={path} path={path} element={<Component />} children={subRoutes?.()} />
                    ))}
                </Route>
            </Routes>
        </HashRouter>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
if(process.env.NODE_ENV === 'production')
    serviceWorkerRegistration.register();
else
    serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
